type StoryMediaProps = {
  readonly src: string;
  readonly alt: string;
  readonly caption?: string;
  readonly className?: string;
  /** CDC-style cover crop ratios */
  readonly ratio?: "square" | "wide" | "card" | "cover";
};

const CECI_CREDIT = "Photo CECI";

/** Full-bleed / panel photography used across the public story. */
export function StoryMedia({ src, alt, caption, className, ratio = "wide" }: StoryMediaProps) {
  const credit = caption ? `${caption} · ${CECI_CREDIT}` : CECI_CREDIT;
  return (
    <figure
      className={`nbs-story-media nbs-story-media--${ratio}${className ? ` ${className}` : ""}`}
    >
      <div className="nbs-story-media__frame">
        <img className="nbs-story-media__img" src={src} alt={alt} loading="lazy" />
      </div>
      <figcaption className="nbs-story-media__caption">{credit}</figcaption>
    </figure>
  );
}

/** CECI field photography — communities, harvests and reforestation. */
export const STORY_IMAGES = {
  forest: "/story/forest.jpg",
  mangrove: "/story/mangrove.jpg",
  vegetation: "/story/vegetation.jpg",
  landscape: "/story/landscape.jpg",
  nature: "/story/nature.jpg",
  canopy: "/story/canopy.jpg",
  planting: "/story/planting.jpg",
  harvest: "/story/harvest.jpg",
  field: "/story/field.jpg",
  community: "/story/community.jpg",
} as const;

/** One photo per story step. */
export const STORY_STEP_IMAGES = {
  1: STORY_IMAGES.forest,
  2: STORY_IMAGES.landscape,
  3: STORY_IMAGES.canopy,
  4: STORY_IMAGES.vegetation,
  5: STORY_IMAGES.nature,
  6: STORY_IMAGES.harvest,
} as const;

export const STORY_PROFILE_IMAGES = {
  "kounounkan-allassoya-moussaya": STORY_IMAGES.community,
  "madina-oula": STORY_IMAGES.field,
} as const;
